import { useEffect } from 'react';

// Env-gated analytics. Set these in your Vercel project settings:
//   REACT_APP_GA_ID       = G-XXXXXXXXXX   (Google Analytics 4)
//   REACT_APP_CLARITY_ID  = xxxxxxxxxx     (Microsoft Clarity)
// Scripts are injected on the client only (never during react-snap prerender),
// so they don't pollute the static HTML or fire fake pageviews at build time.
const GA_ID = process.env.REACT_APP_GA_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;
const isPrerender = typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent || '');

const Analytics = () => {
    useEffect(() => {
        if (isPrerender) return;

        if (GA_ID && !window.__gaLoaded) {
            window.__gaLoaded = true;
            const s = document.createElement('script');
            s.async = true;
            s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
            document.head.appendChild(s);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
            window.gtag('config', GA_ID, { anonymize_ip: true });
        }

        if (CLARITY_ID && !window.__clarityLoaded) {
            window.__clarityLoaded = true;
            (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
                t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
                y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
            })(window, document, 'clarity', 'script', CLARITY_ID);
        }
    }, []);

    return null;
};

export default Analytics;
